// src/utils/reportNaming.js
// Genera nomi file coerenti per tutti i report (con Anno)

function sanitizeName(s = '') {
  return String(s)
    .replace(/[\s]+/g, ' ')
    .trim()
    .replace(/[\\/:*?"<>|]+/g, '-')  // caratteri illegali per filename
    .replace(/[\u0000-\u001F]+/g, '') // control chars
    .replace(/\s+/g, ' ');
}

function compose(parts = [], ext = 'pdf') {
  const name = parts.filter(Boolean).map(sanitizeName).join(' - ');
  return `${name}.${ext}`;
}

/**
 * type: 'settimanale' | 'mensile' | 'statistiche presenze'
 * dateLabel: data incontro o range (es "2025-10-27" o "Ottobre 2025")
 * yearLabel: etichetta dell'anno dal menù (es. "01-Primo", "04-Quarto", ecc.)
 */
export function buildReportNames({ type, dashboardTitle, catechists, dateLabel, yearLabel }) {
  const t = (type || '').toLowerCase();
  // Metto l'Anno come primo elemento per visibilità nei file ordinati per nome
  const base = [yearLabel, dashboardTitle, catechists, dateLabel, `Report ${t}`];
  return {
    pdfName: compose(base, 'pdf'),
    xlsxName: compose(base, 'xlsx'),
  };
}

